/**
 * We have multiple sources of pilots from PageContext: FeaturePilotFlag and Permissions attributes
 * @param {Object} pageContext The server's page context object
 * @returns {Object} merging the pilots source
 */
import type { GlobalAppsPageContext, PilotFlags } from './types';

const pilotsObject = (pageContext: GlobalAppsPageContext): Record<string, boolean | PilotFlags | undefined> => ({
  ...pageContext.FeaturePilotFlag,
  ...pageContext.Permissions,
  ...(pageContext.Permissions || {}).dynamic,
});

/**
 * Returns true if the pilotFlag exists in pageContext, false otherwise
 * @param {Object} pageContext The server's page context object
 * @param {String} pilotFlag Indicate the pilot's string name
 * @returns {Boolean} true if the pilotFlag exists in pageContext, false otherwise
 */
export const isPilotEnabled = (pageContext?: GlobalAppsPageContext | null, pilotFlag?: string) => (pageContext && pilotsObject(pageContext)[pilotFlag] === true) || false;
